import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';

/**
 * @public
 */
export interface IOnItemUploadedPayload {
    progressItemKey: string;
}

/**
 * @public
 */
export interface IUploadItemsActionControlProps {
    itemKey: string | undefined;
}

/**
 * @public
 */
export interface IUploadItemsActionControlOverrides {
    /**
     * Hook to override whether or not the user is permitted to upload.
     */
    isAvailable: boolean;
    /**
     * An override for the key fo the item that will actually receive the uploaded files.
     * Availability checks will not be made against this item.
     */
    targetItemKey: string | undefined;
    /**
     * Hook which is invoked when any item is uploaded.
     */
    onItemUploaded: (payload: IOnItemUploadedPayload) => IItemCacheThunkAction<void>;
}

export const uploadItemsActionControl: ControlFacet<IUploadItemsActionControlProps, IUploadItemsActionControlOverrides> =
    new ControlFacet('uploadItemsActionControl');
